<mat-dialog-content>
  <div class="insight-container">
    <div class="insight-title">
      <div class="title">Confirmation</div>
      <div class="insight-title-icon"><mat-icon>close</mat-icon></div>
    </div>
    
    <div class="insight-content">
      <div class="insight-text">
       Total {{totalFiles.data}}  files processed in db
      </div>
      <mat-dialog-actions>
        
        <button mat-button class="cra-button button-dark" mat-dialog-close (click)="dialogRef.close(true)">Ok</button>
      </mat-dialog-actions>
    </div>
  </div>
</mat-dialog-content>

